<template>
	<div>
		<div ref="option">
			<button
				@click="focus"
				:disabled="disabled"
				:class="{
					'erro-input': classErro,
					'erro-des': isActiveDisabled || alertMsg
				}"
				v-tooltip="tip"
				type="button"
				class="btn btn-white btn-block dropdown-toggle"
				data-toggle="dropdown"
				aria-haspopup="false"
				aria-expanded="false"
				style="
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					height: 28px;
					background: #fff;
					border: 1px solid #d3d3d3;
				"
			>
				<div
					style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
				>
					<slot name="item">
						<span style="font-size: 11px">{{ title }}</span>
					</slot>
				</div>
				<div style="padding-top: 4px">
					<svg
						@click.stop="clearItem()"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						style="width: 16px; height: 16px; margin-left: 2px"
						v-tooltip="'Limpar'"
						v-if="!disabled"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M6 18 18 6M6 6l12 12"
						/>
					</svg>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						style="width: 16px; height: 16px; margin-left: 2px"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M19.5 8.25l-7.5 7.5-7.5-7.5"
						/>
					</svg>
				</div>
			</button>
			<p
				class="help-block"
				style="margin-top: 4px; color: rgb(245, 134, 60)"
				v-show="isActiveDisabled || alertMsg"
			>
				{{ alertMsg ? alertMsg : '' }}
				{{ isActiveDisabled ? 'Você selecionou um registro desativado.' : '' }}
			</p>
			<ul
				v-if="!_isMobile"
				class="dropdown-menu"
				:style="{'max-height': 320 + 'px'}"
				style="overflow: auto; width: 100%; border-radius: 3px; border: none"
			>
				<li style="position: relative; padding: 2px">
					<i
						class="fa fa-search icone-busca"
						style="top: 10px; left: 10px"
						aria-hidden="true"
					></i>
					<input
						ref="searchInput"
						type="text"
						@input="(e) => pesquisar(e.target.value)"
						class="form-control input-sm"
						style="
							padding-left: 25px;
							border: 1px solid rgb(211, 211, 211) !important;
						"
						:value="search"
						placeholder="Pesquisar"
					/>
				</li>
				<li
					:class="{active: active(it)}"
					v-for="(it, idx) in itemsNotDisabled"
					:key="'p' + idx"
				>
					<a @click.prevent.stop="selectItem(it)" href="#">
						{{ label(it) }}
					</a>
				</li>
				<li v-if="itemsNotDisabled.length == 0" class="text-center">
					<div style="padding: 8px">
						<small style="color: #777777"> {{ _traducao('global', 'nenhumRegistroEncontrado') }} </small>
					</div>
				</li>
				<li ref="next" class="text-center" v-if="observed" v-show="hasNextPage">
					<div style="padding: 8px">
						<small>{{ _traducao('global', 'carregandoMaisOpcoes') }}...</small>
					</div>
				</li>
				<li v-show="showDisabled" :class="{active: isActiveDisabled}">
					<a
						@click.prevent.stop="open = !open"
						href="#"
						:style="{color: isActiveDisabled ? '#fff' : 'red'}"
						style="
							display: flex;
							align-items: center;
							justify-content: center;
							line-height: 1px;
						"
					>
						EXIBIR DESATIVADOS
						<i
							class="fa"
							:class="[open ? 'fa-angle-down' : 'fa-angle-up']"
							style="margin-left: 4px; font-size: 14px"
						></i>
					</a>
				</li>
				<li
					v-show="open"
					:class="{active: active(it)}"
					v-for="(it, idx) in itemsDisabled"
					:key="'d' + idx"
				>
					<a @click.prevent.stop="selectItem(it)" href="#">
						{{ label(it) }}
					</a>
				</li>
				<li v-if="open && itemsDisabled.length == 0" class="text-center">
					<div style="padding: 8px">
						<small style="color: #777777"> {{ _traducao('global', 'nenhumRegistroEncontrado') }} </small>
					</div>
				</li>
			</ul>
			<p
				style="position: absolute; color: #a94442 !important"
				class="help-block"
				v-if="classErro"
			>
				{{ classErro }}
			</p>
		</div>
		<modal ref="modalSelect" v-if="_isMobile">
			<Row>
				<Column>
					<h4
						style="
							display: flex;
							align-items: center;
							justify-content: space-between;
						"
					>
						<slot name="item">
							{{ title }}
						</slot>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							style="width: 16px"
							@click.stop="$refs.modalSelect.modalHide()"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M6 18 18 6M6 6l12 12"
							/>
						</svg>
					</h4>
					<Divider />
				</Column>
			</Row>
			<Row>
				<Column>
					<AlertWarning v-if="isActiveDisabled"
						>Você selecionou um registro desativado.</AlertWarning
					>
					<div style="position: relative; margin-bottom: 12px">
						<i
							class="fa fa-search icone-busca"
							style="top: 8px; left: 10px"
							aria-hidden="true"
						></i>
						<input
							ref="searchInput"
							type="text"
							@input="(e) => pesquisar(e.target.value)"
							class="form-control input-sm"
							style="
								padding-left: 25px;
								border: 1px solid rgb(211, 211, 211) !important;
							"
							:value="search"
							placeholder="Pesquisar"
						/>
					</div>
					<div
						:style="{'max-height': 430 + 'px'}"
						style="
							overflow: auto;
							width: 100%;
							border-radius: 3px;
							border: none;
						"
					>
						<div class="items">
							<div
								:class="{active: active(it)}"
								v-for="(it, idx) in itemsNotDisabled"
								:key="'p' + idx"
								@click.prevent.stop="selectItem(it)"
							>
								{{ label(it) }}
							</div>
						</div>
						<div v-if="itemsNotDisabled.length == 0" class="text-center">
							<div style="padding: 8px">
								<small style="color: #777777"> {{ _traducao('global', 'nenhumRegistroEncontrado') }} </small>
							</div>
						</div>
						<div
							ref="next"
							class="text-center"
							v-if="observed"
							v-show="hasNextPage"
						>
							<div style="padding: 8px">
								<small
									>{{ _traducao('global', 'carregandoMaisOpcoes') }}...</small
								>
							</div>
						</div>
						<div v-show="showDisabled" style="margin: 12px 0px">
							<a
								@click.prevent.stop="open = !open"
								href="#"
								style="
									color: red;
									display: flex;
									align-items: center;
									justify-content: center;
									line-height: 1px;
								"
							>
								EXIBIR DESATIVADOS
								<i
									class="fa"
									:class="[open ? 'fa-angle-down' : 'fa-angle-up']"
									style="margin-left: 4px; font-size: 14px"
								></i>
							</a>
						</div>
						<div class="items">
							<div
								v-show="open"
								:class="{active: active(it)}"
								v-for="(it, idx) in itemsDisabled"
								:key="'d' + idx"
								@click.prevent.stop="selectItem(it)"
							>
								{{ label(it) }}
							</div>
						</div>
						<div v-if="open && itemsDisabled.length == 0" class="text-center">
							<div style="padding: 8px">
								<small style="color: #777777"> {{ _traducao('global', 'nenhumRegistroEncontrado') }} </small>
							</div>
						</div>
					</div>
				</Column>
			</Row>
		</modal>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			default: null
		},
		items: {
			type: Array,
			default: () => ({})
		},
		active: {
			type: Function,
			default: () => false
		},
		label: {
			type: Function,
			default: () => ''
		},
		showDisabled: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		filterDisabled: {
			type: Function,
			default: () => false
		},
		classErro: {
			type: String,
			default: null
		},
		observed: {
			type: Boolean,
			default: false
		},
		hasNextPage: {
			type: Boolean,
			default: true
		},
		searchServer: {
			type: Boolean,
			default: false
		},
		searchItems: {
			type: Function,
			default(arr, search) {
				return arr.filter(
					(item) =>
						this.label(item).toLowerCase().indexOf(search.toLowerCase()) > -1
				)
			}
		},
		search: {
			type: String,
			default: ''
		},
		alertMsg: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			open: false,
			observer: null
		}
	},
	mounted() {
		if (this.$refs.next) {
			this.observer = new IntersectionObserver(this.next)
			this.observer.observe(this.$refs.next)
		}
	},
	computed: {
		tip() {
			let str = ''
			const item = this.getActiveItem
			if (item) {
				str += this.label(item)
			}
			return str
		},
		title() {
			const item = this.getActiveItem
			return item ? this.label(item) : _traducao('global', 'escolha').toUpperCase()
		},
		isActiveDisabled() {
			const item = this.getActiveItem
			if (item && this.showDisabled) {
				return this.filterDisabled(item)
			}
			return false
		},
		getActiveItem() {
			return this.items.find((item) => this.active(item))
		},
		itemsNotDisabled() {
			if (this.searchServer) {
				return this.items.filter((item) => !this.filterDisabled(item))
			}
			let arr = this.items
			if (this.showDisabled) {
				arr = this.items.filter((item) => !this.filterDisabled(item))
			}
			if (!this.search) {
				return arr
			}
			return this.searchItems(arr, this.search)
		},
		itemsDisabled() {
			return this.items
				.filter((item) => this.filterDisabled(item))
				.filter(
					(item) =>
						this.label(item).toLowerCase().indexOf(this.search.toLowerCase()) >
						-1
				)
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(val) {
				this.$emit('input', val)
			}
		},
		search(val, oldVal) {
			if (val != oldVal) {
				this.$emit('search', val)
			}
		}
	},
	methods: {
		pesquisar(value) {
			this.debounce(value, this)
		},
		debounce: _.debounce((value, vm) => (vm.search = value), 500),
		next([{isIntersecting, target}]) {
			if (isIntersecting) {
				const parent = target.offsetParent
				const scrollTop = target.offsetParent.scrollTop
				this.$emit('next')
				this.$nextTick(() => {
					parent.scrollTop = scrollTop
				})
			}
		},
		selectItem(item) {
			this.$refs.option.classList.remove('open')
			if (this._isMobile) {
				this.$refs.modalSelect.modalHide()
			}
			this.$emit('select', item)
			this.$emit('input', item)
		},
		clearItem() {
			this.$refs.option.classList.remove('open')
			this.$emit('select', null)
			this.$emit('input', null)
			this.$emit('clear')
		},
		focus(e) {
			this.$nextTick(() => {
				setTimeout(() => {
					const input = this.$refs.searchInput
					input.focus()
				}, 200)
			})
			if (this._isMobile) {
				this.$refs.modalSelect.modalShow('auto')
			}
		}
	}
}
</script>
<style scoped>
.erro-input {
	border-color: #a94442 !important;
}

.erro-des {
	border-color: rgb(245, 134, 60) !important;
}

ul .dropdown-menu {
	top: 0 !important;
}

div.active {
	background-color: rgb(227, 247, 254);
}

.items div {
	padding: 12px 6px;
	border-bottom: 1px solid #dedede;
	font-size: 11px;
}

.items div:last-child {
	border-bottom: none;
}
</style>